import { useTheme } from '@mui/material/styles';
import DescriptionPopper from '@/components/DescriptionPopper';
import RouteDescription from '../RouteDescription';
import { HopAvatar, HopBox, Line, Row, StepStack } from './style';
import Typography from '@mui/material/Typography';
import { BookUser, MapPinHouse, Timer } from 'lucide-react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getHopColor } from '@/utils/getHopColor';
type HopType = {
  address: string;
  name: string | null;
  latency: string[];
  hop: number;
};

function RouteStep(props: { route: HopType[]; expanded: boolean }) {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: props.expanded ? 'column' : 'row',
        width: props.expanded ? '100%' : 'max-content',
      }}
    >
      {props.route.map((hop: HopType, index: number) => {
        const isLast = index === props.route.length - 1;

        return (
          <HopBox key={hop.hop} expanded={props.expanded} isLast={isLast}>
            {props.expanded && !isLast && <Line expanded={true} />}
            <DescriptionPopper
              /** When hovering renders a popper with hop informations */
              description={!props.expanded && <RouteDescription route={hop} />}
              key={hop.hop}
              placement="bottom"
            >
              <StepStack>
                <HopAvatar color={getHopColor(hop.latency, theme)}>
                  {hop.hop}
                </HopAvatar>
                {props.expanded && (
                  <Grid
                    container
                    spacing={2}
                    sx={{ flexGrow: 1, alignItems: 'center' }}
                  >
                    {/** Address Name */}
                    <Row size={isMd ? 12 : 5}>
                      <BookUser color={theme.palette.primary.main} />
                      <Typography variant="body1" noWrap>
                        {hop.name || '-'}
                      </Typography>
                    </Row>

                    {/** Ip Address */}
                    <Row size={isMd ? 12 : 4}>
                      <MapPinHouse color={theme.palette.primary.main} />
                      <Typography variant="body1">{hop.address}</Typography>
                    </Row>

                    {/** Latency */}
                    <Row size={isMd ? 12 : 3}>
                      <Timer color={theme.palette.primary.main} />
                      <Typography variant="body1">
                        {hop.latency.join(' / ')}
                      </Typography>
                    </Row>
                  </Grid>
                )}
              </StepStack>
            </DescriptionPopper>
            {/** Create a line connecting each hop avatar */}
            {!props.expanded && !isLast && <Line expanded={false} />}
          </HopBox>
        );
      })}
    </Box>
  );
}

export default RouteStep;
